import React, { useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { MenuItem, ListItemText } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";

import { StyledMenu } from "./StyledMenu";

const useStyles = makeStyles(() =>
  createStyles({
    menuButton: {
      paddingRight: "20px",
    },
    circleButton: {
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      padding: "10px 0",
      "-ms-flex": "0 0 auto",
      flex: "0 0 auto",
      display: "inline-flex",
      justifyContent: "center",
      verticalAlign: "middle",
      border: "0",
      cursor: "pointer",
      position: "relative",
      outline: "0",
      boxShadow: "0px 2px 5px -1px rgba(0, 0, 0, 0.15)",
    },
    initials: {
      height: "20px",
      fontSize: "16px",
      color: "hsla(317, 51%, 8%, 1)",
    },
  })
);

export const UserMenu = ({ currentApp, initials, permissions, onLogout }) => {
  const [anchorEl, setAnchorEl] = useState();
  const classes = useStyles();
  const history = useHistory();

  const isDev = process.env.NODE_ENV === "development";

  /** @param {[string]} allowedRoles - Array of strings representing allowed roles for the user */
  const hasPermission = (allowedRoles) => {
    return allowedRoles.some((role) => permissions.indexOf(role) >= 0);
  };

  /** @param {React.MouseEvent} event */
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.menuButton}>
      <button
        color="primary"
        onClick={handleClick}
        className={classes.circleButton}
      >
        <div className={classes.initials}>{initials || ""}</div>
      </button>
      <StyledMenu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {/* Reinstate this when we're ready to give investors and managers access. */}
        {/* {hasPermission(["user-admin", "investor", "manager"]) ? ( */}
        {hasPermission(["user-admin"]) ? (
          <MenuItem
            onClick={() => {
              if (currentApp === "DODO") {
                history.push("/user-admin");
              } else {
                const path = "/utilities/user-admin";
                isDev === null
                  ? (location.href = `http://localhost:3002${path}`)
                  : (location.href = path);
              }
            }}
          >
            <ListItemText primary="User Admin" />
          </MenuItem>
        ) : null}
        <MenuItem onClick={onLogout}>
          <ListItemText primary="Logout" />
        </MenuItem>
      </StyledMenu>
    </div>
  );
};

UserMenu.propTypes = {
  /**
   * Function that will be called when a menu item is selected
   * @param {number} selectedIndex
   */
  onLogout: PropTypes.func.isRequired,
  /**
   * The current App that's using this component
   */
  currentApp: PropTypes.string.isRequired,
  /**
   * User Initials that will be displayed in the button
   */
  initials: PropTypes.string.isRequired,
  /**
   * An array containing the user's permissions
   */
  permissions: PropTypes.array.isRequired,
};
